import React from 'react';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  className?: string;
  children?: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();
  return (
    <footer className={`bg-neutral-800 text-neutral-300 text-sm shadow rounded-t-xl pt-5 pb-5 px-8 py-3 flex flex-col md:flex-row md:items-center md:justify-between border-t border-neutral-200 ${className}`}>
      <div className="mb-2 md:mb-0">
        <a href="https://homeme.app" target="_blank" rel="noopener noreferrer" className="hover:underline">homeme.app</a> All rights reserved. © {new Date().getFullYear()} &nbsp;
        HomeMe VOF | KVK: 96205334 | BTW: NL867512428B01
      </div>
      <div className="flex gap-4 md:gap-6 justify-center md:justify-end">
        <a href="https://homeme.app/pdf/Privacyverklaring_HomeMe.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a>
        <a href="https://homeme.app/pdf/Algemene_voorwaarden_HomeMe.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">{t('terms_and_conditions')}</a>
      </div>
      {children}
    </footer>
  );
};

export default Footer; 